/**
 * SVG Icon Sprite
 *
 * Usage in HTML:
 *
 * Add the data-icons attribute to the body:
 * <body data-icons="PATH_TO_ICON_SPRITE">
 *
 * Use this code to display an icon:
 * (Css is also required to display the icon correctly)
 * <svg><use href="{{ "#icon-FILENAME" }}"/></svg>
 */
/* eslint-disable */
/**
 * Insert a hidden SVG containing icons at the top of the body
 */
const bodyElement = document.querySelector("body")
const dataset = bodyElement.dataset

const inlineFile = (dataAttr, iconsPath) => {
	const request = new XMLHttpRequest()
	request.open("GET", iconsPath, true)

	request.onload = () => {
		if (request.status >= 200 && request.status < 400) {
			const svgIcon = request.responseXML.documentElement
			if (dataAttr.indexOf("Masks") != -1) {
				svgIcon.setAttribute("class", "screen-reader")
			} else {
				svgIcon.setAttribute("hidden", true)
			}
			svgIcon.setAttribute("aria-hidden", true)
			bodyElement.insertBefore(svgIcon, bodyElement.firstChild)
			delete dataset[dataAttr]
		}
	}

	request.send()
}

if (!Object.values(dataset).length) {
	console.warn(`No body attributes found for SVG icon sprite`)
}

Object.entries(dataset).forEach(([key, value]) => {
	inlineFile(key, value)
})
